// extracted by mini-css-extract-plugin
export default {"submitButton":"ResetPassword_submitButton__I1czZ","errorMessage":"ResetPassword_errorMessage__LzmfX"};